module.exports = __webpack_public_path__ + "static/media/CTLI_17-147w.30dd8928.webp";